export default class RequestDownload {
  constructor(el) {
    this.el = el
    this.setVars()
    this.init()
  }

  setVars() {
    this.requestingClass = 's-downloading'
    this.errorClass = 's-error'
    this.completeClass = 's-complete'
    this.failed = 's-failed'
    this.button = this.el.querySelector('button')
    this.form = this.el.querySelector('[data-form]')
    this.requestingMessage = this.el.querySelector('[data-downloading-message]')
  }

  init() {
    if (this.button) {
      this.el.addEventListener('submit', this.handleRequestDownload)
    }
  }

  handleRequestDownload = (e) => {
    this.form.classList.add(...['hidden'])
    this.requestingMessage.classList.remove(...['hidden', 'opacity-0'])
  }

  // handleRequestDownload = (e) => {
  //   e.preventDefault()
  //   this.el.classList.add('opacity-10')
  //   const data = {
  //     action: 'portal-downloads/download/request-file',
  //     assetId: this.assetId,
  //     email: this.email,
  //     token: this.token,
  //   }
  //
  //   const options = {
  //     method: 'GET',
  //     url: '/',
  //     responseType: 'blob',
  //     headers: {
  //       'Content-Type': 'application/x-www-form-urlencoded',
  //       'X-CSRF-Token': this.CSRFToken,
  //     },
  //     data: qs.stringify(data),
  //   }
  //   axios(options)
  //     .then((response) => {
  //       console.log(response)
  //       e.preventDefault()
  //       this.el.classList.remove('opacity-10')
  //       FileDownload(response.data, 'test.zip')
  //     })
  //     .catch((error) => {
  //       console.log(error)
  //     })
  // }
}
